import axiosInstance from "../configs/axios";
import { route } from "ziggy-js";

export async function submitCpraRequest(formData) {
    return (await axiosInstance.post(route("jsapi.cpra"), formData)).data;
}
